import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../../../api/agent";
import { AppFilter } from "../../../../models/app/AppModels";
import { AppResponse } from "../../../../models/app/AppResponse";
import { Part, PartImage } from "../../../../models/features/Part/Parts";

export const partApi = createApi({
  reducerPath: "partApi",
  baseQuery: axiosBaseQuery(),

  endpoints: (build) => ({
    addPart: build.mutation<AppResponse<Part>, { data: Part }>({
      query({ data }) {
        return {
          url: `api/AddPart`,
          method: "post",
          data: data,
        };
      },
    }),

    addPartImage: build.mutation<AppResponse<PartImage>, { data: any }>({
      query({ data }) {
        return {
          url: `api/AddPartImage`,
          method: "post",
          headers: {
            "Content-Type": "multipart/form-data; ",
          },
          data: data,
        };
      },
    }),
    getParts: build.mutation<any, { paging: AppFilter }>({
      query: ({ paging }) => ({
        url: `api/GetParts`,
        method: "post",
        data: paging,
      }),
    }),
    getPartById: build.mutation<any, { data: any }>({
      query({ data }) {
        return {
          url: `api/GetPartById?partId=${data}`,
          method: "post",
          data: data,
        };
      },
    }),
    deletePart: build.mutation<any, { data: any }>({
      query({ data }) {
        return {
          url: `api/DeletePart`,
          method: "delete",
          data: data,
        };
      },
    }),
    editPart: build.mutation<AppResponse<Part>, { data: any }>({
      query({ data }) {
        return {
          url: `api/EditPart`,
          method: "post",
          data: data,
        };
      },
    }),
    deletePartImage: build.mutation<any, { data: any }>({
      query({ data }) {
        return {
          url: `api/DeletePartImage`,
          method: "delete",
          data: data,
        };
      },
    }),
  }),
});

export const {
  useAddPartMutation,
  useAddPartImageMutation,
  useGetPartsMutation,
  useGetPartByIdMutation,
  useDeletePartMutation,
  useEditPartMutation,
  useDeletePartImageMutation,
} = partApi;
